import React from 'react';
import PropTypes from 'prop-types';
import { Redirect, Route, Switch } from 'react-router-dom';
import { IfPermission } from '@folio/stripes-core';
import DataProvider from './providers/DataProvider';
import CopyCatSearch from './components/CopyCatSearch';
import CopycatRoute from './routes/CopycatRoute';
import CopycatBibEditRoute from './routes/CopycatBibEditRoute';
import CopycatMarcEditRoute from './routes/CopycatMarcEditRoute';

function CopyCat({ basePath, redirectTo }) {
  console.log('basePath-copycat: ', basePath, 'redirectTo: ', redirectTo);

  return (
    <IfPermission perm="ui-plugin-copycat.module.search">
      <DataProvider>
        <Switch>
          {/* {redirectTo && (
        <Redirect from={basePath} to={`${basePath}/${redirectTo}`} />
      )} */}
          <Route
            path={`${basePath}/search`}
            render={() => <CopycatRoute basePath={basePath} />}
          />
          <Route
            path={`${basePath}/copycat/edit/:id/bibframe`}
            component={CopycatBibEditRoute}
          />
          <Route
            path={`${basePath}/copycat/edit/:id/marc`}
            component={CopycatMarcEditRoute}
          />
        </Switch>
      </DataProvider>
    </IfPermission>
  );
}

CopyCat.propTypes = {
  basePath: PropTypes.string,
  redirectTo: PropTypes.string,
};

export default CopyCat;
